import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Sentry, initSentry } from "./config/sentry";
import App from "./App";
import "./index.css";
import "./tailwind.css"; // Tailwind CSS v4 configuration (deve vir por último)

// Initialize Sentry from config  
initSentry();

// Graceful error fallback component following industry best practices
const ErrorFallback = ({ error, resetError }: { error: unknown; resetError: () => void }) => {
  const errorMessage = error instanceof Error ? error.message : 'Um erro desconhecido ocorreu';
  const errorStack = error instanceof Error ? error.stack : undefined;
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      backgroundColor: '#1a1a1a',
      color: '#e0e0e0',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{
        maxWidth: '600px',
        textAlign: 'center',
        backgroundColor: '#2a2a2a',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
      }}>
        <h1 style={{ 
          fontSize: '2rem', 
          marginBottom: '1rem',
          color: '#F4CC04',
        }}>
          Algo deu errado
        </h1>
        <p style={{ 
          marginBottom: '1.5rem',
          lineHeight: '1.6',
          color: '#b0b0b0',
        }}>
          Desculpe, encontramos um problema inesperado. Não se preocupe, nossa equipe já foi notificada e estamos trabalhando para resolver isso.
        </p>
        {import.meta.env.DEV === true && (
          <details style={{ 
            marginBottom: '1.5rem',
            textAlign: 'left',
            backgroundColor: '#1a1a1a',
            padding: '1rem',
            borderRadius: '4px',
            fontSize: '0.875rem',
            color: '#ff6b6b',
          }}>
            <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>
              Detalhes do erro (modo desenvolvimento)
            </summary>
            <pre style={{ 
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              margin: 0,
            }}>
              {errorMessage}
              {errorStack && `\n\n${errorStack}`}
            </pre>
          </details>
        )}
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button
            onClick={resetError}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#F4CC04',
              color: '#1a1a1a',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, background-color 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#d4b004'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#F4CC04'}
          >
            Tentar novamente
          </button>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: 'transparent',
              color: '#e0e0e0',
              border: '1px solid #4a4a4a',
              borderRadius: '4px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'border-color 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.borderColor = '#6a6a6a'}
            onMouseOut={(e) => e.currentTarget.style.borderColor = '#4a4a4a'}
          >
            Ir para início
          </button>
        </div>
      </div>
    </div>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary 
        fallback={({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />}
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
